var SEND_MESSAGE_START = 'SEND_MESSAGE_START';
var SEND_USER_MESSAGE = 'SEND_USER_MESSAGE';
var SEND_FILE_MESSAGE = 'SEND_FILE_MESSAGE';
var UPDATE_USER_MESSAGE = 'UPDATE_USER_MESSAGE';
var DELETE_MESSAGE = 'DELETE_MESSAGE';
var LEAVE_CHANNEL = 'LEAVE_CHANNEL';
var CREATE_CHANNEL = 'CREATE_CHANNEL';
export { CREATE_CHANNEL as C, DELETE_MESSAGE as D, LEAVE_CHANNEL as L, SEND_USER_MESSAGE as S, UPDATE_USER_MESSAGE as U, SEND_FILE_MESSAGE as a, SEND_MESSAGE_START as b };